import Vue from 'vue'
import App from './App'

Vue.config.productionTip = false

import router from './router'
import store from './store'

import './configs/index'

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')